export default "__VITE_ASSET__g9q5BZy___"